import React, { useContext } from 'react';
import { Box, Button } from "@material-ui/core"
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import CustomTable from "../../common/CustomTable";
import {useDigitalPR} from '../hooks/useDigitalPR';
import { storeContext } from '../../provider/Provider';
import SkeletonWrapper from '../../common/SkeletonWrapper';
import VideoPopup from '../../common/VideoPopup';
import { StyledTablePagination } from '../styles/index.style';

const SimplePagination = ({rowPerPage, total}) => (
   <Box style={{display: "flex", justifyContent: "end", alignItems: "center", width: "100%"}}>
      <Box style={{display: "flex", gap: "35px", fontSize: 15, padding: "15px 0 6px", marginRight: "35px" }}>
         <Box>
            Row per page: {rowPerPage}
         </Box>
         <Box>
            1 - {rowPerPage} of {total}
         </Box>
      </Box>
   </Box>
)

SimplePagination.propTypes = {
   rowPerPage: PropTypes.number,
   total: PropTypes.number,
 };

 SimplePagination.defaultProps = {
   rowPerPage: 0,
   total: 0,
 };


const PRTable = () => {
   const history = useHistory();
   const { state } = useContext(storeContext);
   const { 
      handleCampaignPageChange, 
      handleCampaignPerPageChange, 
      columns, 
      style, 
      childStyle, 
      childColumns, 
      closeVideoPopup,
      filteredCampaigns,
      getRowStyle,
    } = useDigitalPR();

   return (
      <SkeletonWrapper condition={state.digitalPR.campaignsLoading}>
         <>
            <CustomTable 
               data={filteredCampaigns} 
               columns={columns} 
               style={style} 
               childColumns={childColumns} 
               childStyle={childStyle} 
               condensed
               rowStyle={getRowStyle}
               />
            <Box display="flex" justifyContent="end" pb={5}>
               <StyledTablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={state.digitalPR.totalCampaigns}
                  rowsPerPage={state.digitalPR.campaignFilters.perPage}
                  page={state.digitalPR.campaignFilters.page}
                  onPageChange={handleCampaignPageChange}
                  onRowsPerPageChange={handleCampaignPerPageChange}
                  labelRowsPerPage="Rows:"
               />
               <Button
                  varian="ghost" 
                  style={{ color: '#509EE9'}}
                  onClick={() => history.push('/digital-pr/active-full-view')}>
                  View All &gt;
               </Button>
            </Box>
         </>
         {state.digitalPR.isVideoOpen && <VideoPopup isOpen={state.digitalPR.isVideoOpen} videoUrl={state.digitalPR.videoUrl} onClose={closeVideoPopup} />}
      </SkeletonWrapper>
   )
}

export default PRTable;